import React from 'react'
import { observer } from 'mobx-react'
import TotalAverage from 'support/displays/TotalAverage'

function TotalPerGuestCalculated ({ location, unitType, guestLocation }) {
  return (
    <TotalAverage dividerName={`Guest_Count_${guestLocation}`} totalName={`${unitType}_${location}`}/>
  )
}

export default observer(TotalPerGuestCalculated)
